import Switch, {Case, Default} from 'react-switch-case';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import UserTransaction from './UserTransactions'
import MarketTransaction from './MarketTransactions'
import * as firebase from 'firebase';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

// import MarketTransactionsScreen from '././screens/MarketTransactionsScreen'

/**
 * receives sessionid and uid props from simulationContainer.js
 *
 * this component is the parent component of both user and market transactions, and passes a transaction prop to both
 */
class TransactionSwitcher extends Component {
    constructor() {
        //console.log("TransactionSwitcher created");
        super();
        this.state = {
            value: "Market",
            userTransactions: [],
            marketTransactions: []
        }
    }

    /**
     * handles the change between user and market render
     * @param event
     */
    handleChange(event) {
        //console.log("TransactionSwitcher handleChange");
        this.setState({
            value: event.target.value
        })
    }

    shouldComponentUpdate(){
      if (this.canRender){
        this.canRender = false;
        return true;
      }
      return false;
    }

    /**
     * this listener grabs all of the user transactions and pushes them to state.usertrns
     * TODO should be child_added
     */
    componentDidMount() {
        this.canRender = true;
        this.renderLoop = setInterval(()=>{ this.canRender = true; }, 1000);
        //console.log("TransactionSwitcher componentDidMount");
        this.userTransRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Transactions");
        this.userTransRef.on('value', snap => {
            var userdata = snap.val();
            //console.log(data);
            var usertrns = [];
            if (!!userdata) {
                for (var key in userdata) {
                    if (userdata.hasOwnProperty(key)) {
                        usertrns.push(userdata[key]);
                    }
                }
            }
            //console.log(this.state,"User");
            this.setState({
                userTransactions: usertrns.reverse()
            });

        });

        //this listener grabs all of the market transactions and pushes them to
        //state.usertrns
        this.marketTransRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Transactions");
        this.marketTransRef.on('child_added', snap => {
            var marketdata = snap.val();

            //console.log(marketdata);
            let trans = this.state.marketTransactions || [];
            trans.unshift(marketdata);
            // var markettrns = [];
            // if (!!marketdata) {
            //     for (var key in marketdata) {
            //         if (marketdata.hasOwnProperty(key)) {
            //             markettrns.push(marketdata[key]);
            //         }
            //
            //     }
            // }
            //console.log(this.state,"market");
            this.setState({
                marketTransactions: trans.slice(0,20)
            });

        });
    }

    componentWillUnmount() {
        //console.log("TransactionSwitcher componentWillUnmount");
        this.userTransRef.off();
        this.marketTransRef.off();
    }


    render() {
        ///console.log("TransactionSwitcher render");
        let transactionType;
        if (this.state.value === "User") {
            transactionType = <UserTransaction transaction={this.state.userTransactions}/>

        } else if (this.state.value === "Market") {
            transactionType = <MarketTransaction transaction={this.state.marketTransactions}/>
        } else {
            transactionType = <span>Nothing!</span>
        }

        return (
            <div className="transaction-log-div">
                <select
                    className='transaction-switcher'
                    ref="selectOption"
                    onChange={(e) => this.handleChange(e)}>
                    <option defaultValue="Market">Market</option>
                    <option value="User">User</option>
                </select>
                {transactionType}
                {/*<div>*/}
                {/*<MarketTransactionsScreen props = {this.state.marketTransactions}/>*/}
                {/*</div>*/}

            </div>

        );
    }
}

TransactionSwitcher.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string
};

export default TransactionSwitcher;



// WEBPACK FOOTER //
// ./src/components/Orderbook/TransactionSwitcher.js